import { addTruthyParamsToUrl } from '@zapier/url-utils';
import { atoms, Link } from '@zapier/marketing-ui';
import { AuthType } from '../../types';

type Props = {
  authType: AuthType;
};

const className = `${atoms.bodySM} ${atoms.textNeutral800} ${atoms.textCenter}`;

export function AltAuthCta({ authType }: Props) {
  if (authType === 'email') {
    return (
      <p className={className}>
        Or{' '}
        <Link
          href={addTruthyParamsToUrl(window.location.href, {
            forceLoginDisplayForm: true,
          })}
        >
          log in with Google, Facebook, or Microsoft.
        </Link>
      </p>
    );
  }

  return (
    <p className={className}>
      Or{' '}
      <Link
        href={addTruthyParamsToUrl(window.location.href, {
          forceLoginDisplayForm: true,
        })}
      >
        use your email address to log in.
      </Link>
    </p>
  );
}
